<template>
  <aside class="po-sidebar" :class="{ expanded: isHovered }" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <router-link to="/" class="po-sidebar-logo">
      <img src="/images/logo.png" alt="logo" class="po-logo-icon" style="width: 32px; height: 32px; object-fit: contain; border-radius: 4px;" />
      <transition name="fade-text">
        <span v-if="isHovered" class="po-logo-text">ecoWise Renewable Energy</span>
      </transition>
    </router-link>

    <nav class="po-sidebar-nav">
      <router-link to="/" class="po-nav-item" :class="{ active: $route.path === '/' }" :title="$t('bottomNav.首页')">
        <div class="po-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        </div>
        <transition name="fade-text"><span v-if="isHovered" class="po-nav-label">{{ $t('bottomNav.首页') }}</span></transition>
      </router-link>

      <router-link to="/flash-options" class="po-nav-item" :class="{ active: $route.path === '/flash-options' }" :title="$t('bottomNav.闪期权')">
        <div class="po-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
        </div>
        <transition name="fade-text"><span v-if="isHovered" class="po-nav-label">{{ $t('bottomNav.闪期权') }}</span></transition>
      </router-link>

      <router-link to="/assets" class="po-nav-item" :class="{ active: $route.path === '/assets' }" :title="$t('assets.我的账户') || $t('bottomNav.资产')">
        <div class="po-nav-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 10h20"/><path d="M12 4v16"/></svg>
        </div>
        <transition name="fade-text"><span v-if="isHovered" class="po-nav-label">{{ $t('assets.我的账户') || $t('bottomNav.资产') }}</span></transition>
      </router-link>
    </nav>

    <div class="po-sidebar-bottom">
      <div v-if="walletAddress" class="po-sidebar-wallet" :title="walletAddress">
        <div class="po-wallet-dot"></div>
        <transition name="fade-text"><span v-if="isHovered" class="po-wallet-addr">{{ shortAddress }}</span></transition>
      </div>
    </div>
  </aside>
</template>

<script>
import userStore from '@/utils/userStore'

export default {
  name: 'DesktopSidebar',
  data() {
    return {
      walletAddress: '',
      isHovered: false
    }
  },
  computed: {
    shortAddress() {
      if (!this.walletAddress) return ''
      return this.walletAddress.slice(0, 6) + '...' + this.walletAddress.slice(-4)
    }
  },
  mounted() {
    this.walletAddress = userStore.getWalletAddress?.() || localStorage.getItem('wallet_address') || ''
    window.addEventListener('user-connected', this._refresh)
  },
  beforeUnmount() {
    window.removeEventListener('user-connected', this._refresh)
  },
  methods: {
    _refresh() {
      this.walletAddress = userStore.getWalletAddress?.() || localStorage.getItem('wallet_address') || ''
    }
  }
}
</script>

<style scoped>
.po-sidebar { display: none; }

@media (min-width: 769px) {
  .po-sidebar {
    display: flex;
    flex-direction: column;
    width: var(--po-sidebar-w, 64px);
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 200;
    background: #fff;
    border-right: 1px solid #dce1e8;
    overflow: hidden;
    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .po-sidebar.expanded {
    width: var(--po-sidebar-expanded, 220px);
    box-shadow: 4px 0 20px rgba(0,0,0,0.06);
  }

  .po-sidebar-logo {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px 0;
    margin: 0 auto;
    width: 100%;
    justify-content: center;
    text-decoration: none;
    border-bottom: 1px solid rgba(255,255,255,0.04);
    min-height: 60px;
  }

  .po-sidebar.expanded .po-sidebar-logo {
    padding-left: 20px;
    justify-content: flex-start;
  }

  .po-logo-icon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
  }

  .po-logo-text {
    color: #1a2233;
    font-size: 15px;
    font-weight: 700;
    white-space: nowrap;
    letter-spacing: -0.01em;
  }

  .po-sidebar-nav {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 12px 8px;
  }

  .po-sidebar.expanded .po-sidebar-nav {
    padding: 12px 10px;
  }

  .po-nav-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 0;
    justify-content: center;
    border-radius: 10px;
    text-decoration: none;
    color: #78909c;
    position: relative;
    transition: all 0.15s ease;
  }

  .po-sidebar.expanded .po-nav-item {
    padding: 11px 16px;
    justify-content: flex-start;
  }

  .po-nav-item:hover {
    color: #1a2233;
    background: #f1f8e9;
  }

  .po-nav-item.active {
    color: #2e7d32;
    background: #e8f5e9;
  }

  .po-nav-item.active::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 20px;
    border-radius: 0 3px 3px 0;
    background: #2e7d32;
  }

  .po-sidebar.expanded .po-nav-item.active::before {
    left: -10px;
  }

  .po-nav-icon {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .po-nav-icon svg {
    width: 20px;
    height: 20px;
  }

  .po-nav-item.active .po-nav-icon svg {
    stroke: #2e7d32;
  }

  .po-nav-label {
    font-size: 13.5px;
    font-weight: 500;
    white-space: nowrap;
    letter-spacing: 0.01em;
  }

  .po-nav-item-sm .po-nav-icon svg {
    width: 18px;
    height: 18px;
  }

  .po-sidebar-bottom {
    padding: 8px 8px 14px;
    border-top: 1px solid rgba(255,255,255,0.04);
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .po-sidebar.expanded .po-sidebar-bottom {
    padding: 8px 10px 14px;
  }

  .po-sidebar-wallet {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: center;
    padding: 10px 0;
    border-radius: 8px;
    background: rgba(46,204,113,0.06);
    margin-top: 4px;
  }

  .po-sidebar.expanded .po-sidebar-wallet {
    padding: 10px 14px;
    justify-content: flex-start;
  }

  .po-wallet-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #2e7d32;
    flex-shrink: 0;
  }

  .po-wallet-addr {
    font-size: 11.5px;
    font-family: 'SF Mono', 'Fira Code', monospace;
    color: #78909c;
    white-space: nowrap;
  }

  .fade-text-enter-active { transition: opacity 0.2s ease 0.05s; }
  .fade-text-leave-active { transition: opacity 0.1s ease; }
  .fade-text-enter-from, .fade-text-leave-to { opacity: 0; }
}
</style>
